import { Link } from 'react-router-dom';
import ResponsiveContainer from '../../common/ResponsiveContainer';

const NoAccess = () => {
  return (
    <ResponsiveContainer className='flex flex-col my-[40vh] items-center font-montserrat font-semibold'>
      <div className='flex flex-col gap-[3rem] justify-center bg-white p-5 rounded-lg shadow'>
        <h1 className='text-2xl text-red-2'>No tienes permiso de ver este contenido</h1>
        <Link to='/' className='text-2xl p-2 bg-red-2 text-white shadow rounded-lg w-fit mx-auto'>
          Volver al inicio
        </Link>
      </div>
    </ResponsiveContainer>
  );
};

export default NoAccess;
